import { GET_MR_PARAMETERS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    vitals_info: VitalsInfo[];
}

export interface VitalsInfo {
    val?: number;
    val_string?: string;
    range: { low: number; high: number };
    display_time?: string;
    result?: string;
}

export default (vitalId: string, plId: string): Promise<Response> => {
    return fetchWithRefresh(GET_MR_PARAMETERS(vitalId, plId)).then((res) => res.json());
};
